import React, {useContext, useEffect} from 'react';
import {BrowserRouter as Router, useLocation} from 'react-router-dom';
import {LoginProvider} from './contexts/loginContext';
import routes, {renderRoutes} from './routes';
import {BASENAME} from './config/constant';
import './components/Utilitarios/ensure-basename';
import {ConfigContext} from './contexts/ConfigContext';
import {ModuloControleProvider} from './contexts/ModuloControleContext';
import Swal from 'sweetalert2';
import axios from './services/axios';
import {Toaster} from 'react-hot-toast';
import ModalEspionar from './views/modal/espionar/modalEspionar';
import {decode as base64_decode} from 'base-64';
import {NotificationsProvider} from './realtime/NotificationsProvider';
import {RealtimeProvider} from './realtime/RealtimeProvider';
import RealtimeControlBridge from './realtime/RealtimeControlBridge';
import DossieRealtimeBridge from './realtime/DossieRealtimeBridge';
//import {GoogleReCaptchaProvider, GoogleReCaptcha} from 'react-google-recaptcha-v3';

const App = () => {
  const configContext = useContext(ConfigContext);
  const {dispatch} = configContext;
  // const location = useLocation(); // Descomentar isso

  const sessionsStr = sessionStorage.getItem('ddesp');
  let sessions = sessionsStr ? JSON.parse(base64_decode(sessionsStr)) : {};
  const session = sessions[37] ?? null;

  // Definir canais baseado no contexto
  const channels = session !== null
    ? session
    : []; // Canais normais do usuário

  return (
    <React.Fragment>
      <Router basename={BASENAME}>
        <LoginProvider>
          <RealtimeProvider channels={channels}>
            <RealtimeControlBridge />
            <DossieRealtimeBridge />
            <NotificationsProvider> 
              <ModuloControleProvider>
                {renderRoutes(routes)}
                {configContext.state.espionarSefaz === true && <ModalEspionar />}
              </ModuloControleProvider>
             </NotificationsProvider>
          </RealtimeProvider>
        </LoginProvider>
      </Router>
      <Toaster position='top-right' />
    </React.Fragment>
  );
};

export default App;
